import type { FaireProductEntity } from "../../entity_types/product";

export const p_c78rwd7dae: FaireProductEntity = {
  token: "p_c78rwd7dae",
  type: "product",
  name: "Native Copper Specimen ~ Michigan Crystals ~ Minerals",
  brandToken: "b_t2bh3wmq82",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2a1f0ced16d045cb74ff67ef9a524c7b5158e1b1ac24a36b35a111056b67d380.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21335d48a93d8b54a408ab286251b46e9d7483094c7216171d93ca247b3ddac3.jpeg",
    "https://cdn.faire.com/fastly/df3230e7f868e3a61904f10387d209f22dfad11d193cc319fad6d2ecc3a6dfc8.jpeg",
  ],
  priceDollars: 4.16,
  description:
    'This listing is for a piece of Native Copper that measures approximately 1.5" from Michigan, USA.\n\nCopper is known as a metal of energy flow, healing, and protection. Believed to enhance vitality, balance emotions, and stimulate energy, it is often associated with grounding and the physical body. This conductive metal is cherished for its ability to amplify intentions and connect with Earth’s energies.\n\nScientifically, Copper (Cu) is a natural element with excellent conductivity, widely used in electrical and thermal applications. Historically, copper has been utilized for thousands of years, revered by ancient civilizations for its healing properties and use in tools and jewelry. Copper has a Mohs hardness of 2.5 to 3.',
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:19.499Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
